import { AppBar } from "./AppBar";
import { Menu } from "../Menu";
import { Layout as RaLayout } from "react-admin";
import { useQuery } from "react-query";
import { useScreenWidth } from "../media";
import Alert from "@mui/material/Alert";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const Layout = (props: any) => {
	return (
		<RaLayout {...props} appBar={AppBar} menu={Menu}>
			<WebexStatusAlert />
			{props.children}
		</RaLayout>
	);
};

const WebexStatusAlert = () => {
	const greaterThanSm = useScreenWidth("sm");

	const fetchWebexStatus = () =>
		fetch("/webex/health").then((response) => response.json());

	const { data } = useQuery("webexServiceStatus", fetchWebexStatus, {
		refetchInterval: 60 * 1000,
	});

	if (!data) {
		return;
	}

	return data.status !== "healthy" ? (
		<Alert
			sx={{
				position: "relative",
				top: 12,
				marginTop: { xs: 0, sm: 1.5 },
				marginBottom: 1.5,
				maxWidth: 700,
			}}
			severity="error"
			icon={greaterThanSm && <ErrorOutlineIcon fontSize="inherit" />}
		>
			Webex is currently experiencing issues. If the issues persist, you may
			implement your manual coordination process. You will be notified by email
			when the issues are resolved.
		</Alert>
	) : null;
};
